import { useEffect, useState } from "react";
import { api, useSeo } from "@/lib/api";
import StoreCard from "@/components/StoreCard";
import Breadcrumbs from "@/components/Breadcrumbs";
import { Search } from "lucide-react";

export default function Stores() {
  useSeo("All Stores — SharePromos", "Browse verified coupons and promo codes from 500+ top online retailers.", {
    keywords: "store directory, coupon sites, promo code stores, retailer list, brand coupons, online stores",
  });
  const [stores, setStores] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/stores", { params: { limit: 500 } }).then((r) => setStores(r.data));
  }, []);

  const filtered = stores.filter((s) => s.name.toLowerCase().includes(q.toLowerCase()));
  const groups = filtered.reduce((acc, s) => {
    const letter = s.name[0].toUpperCase();
    (acc[letter] = acc[letter] || []).push(s);
    return acc;
  }, {});
  const letters = Object.keys(groups).sort();

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 md:py-20" data-testid="stores-page">
      <Breadcrumbs items={[{ label: "Stores" }]} />
      <p className="overline mb-4">Directory</p>
      <h1 className="font-display text-4xl md:text-6xl tracking-tighter uppercase mb-8">All Stores</h1>
      <div className="relative max-w-md mb-12">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
        <input
          data-testid="stores-filter-input"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Filter stores…"
          className="w-full pl-10 pr-4 py-3 border border-slate-300 rounded-sm text-sm focus:border-slate-950 focus:outline-none"
        />
      </div>

      {letters.map((letter) => (
        <div key={letter} className="mb-12">
          <p className="font-display text-3xl tracking-tighter text-slate-300 mb-4">{letter}</p>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {groups[letter].map((s) => <StoreCard key={s.slug} store={s} />)}
          </div>
        </div>
      ))}
      {filtered.length === 0 && (
        <p className="text-slate-500" data-testid="no-stores">No stores match your search.</p>
      )}
    </div>
  );
}
